import { Box, Button, Stack, Step, StepButton, StepContent, Typography } from "@mui/material"
import { If } from "lib/@components/switch.js"
import Iconify from "minimals-template/components/Iconify.js"

export function buildWizardSteps({
    steps,
    currentStep,
    lastStep,
    backButtonText,
    backButtonIcon,
    continueButtonText,
    finishButtonText,
    dataCy,
    onBack,
    onSelectStep,
    onContinue,
}) {
    return steps.map(stepContent)

    function stepContent(step = {}, index) {
        const { title, subtitle, summary, description, canContinue, content } = step
        const isSelectedStep = index === currentStep
        const isFinalStep = index === lastStep
        const canProceed = canContinue !== false
        const continueLabel = isFinalStep ? finishButtonText : continueButtonText
        const stepTitle = title || `Step ${index + 1}`
        const stepSubtitle = renderSubtitleOrSummary({ subtitle, summary, isSelectedStep })

        return (
            <Step key={index} completed={index < currentStep}>
                <StepButton
                    onClick={onSelectStep(index)}
                    disabled={index > currentStep}
                    data-cy={`${dataCy}-step-label-${index}`}
                    optional={
                        <If value={stepSubtitle}>
                            <Typography variant="body1" color="text.secondary">
                                {stepSubtitle}
                            </Typography>
                        </If>
                    }
                >
                    {stepTitle}
                </StepButton>
                <StepContent sx={{ borderLeftColor: "divider" }}>
                    <If value={isSelectedStep}>
                        <Stack spacing={3} data-cy={`${dataCy}-step-content-${index}`}>
                            <If value={description}>
                                <Typography variant="body2" color="text.primary">
                                    {description}
                                </Typography>
                            </If>
                            <If value={content}>
                                <Box>{content}</Box>
                            </If>

                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                                <If value={index > 0}>
                                    <Button onClick={onBack(index)} data-cy={`${dataCy}-back-${index}`}>
                                        <Iconify icon={backButtonIcon} />
                                        {backButtonText}
                                    </Button>
                                </If>
                                <Button
                                    variant="contained"
                                    onClick={onContinue(index)}
                                    disabled={!canProceed}
                                    data-cy={`${dataCy}-continue-${index}`}
                                >
                                    {continueLabel}
                                </Button>
                            </Stack>
                        </Stack>
                    </If>
                </StepContent>
            </Step>
        )
    }

    function renderSubtitleOrSummary({ subtitle, summary, isSelectedStep }) {
        if (isSelectedStep) return subtitle
        return summary || subtitle
    }
}
